module.exports = __webpack_public_path__ + "img/208.ad7ab404.jpg";